import React from 'react'
import { connect } from 'react-redux'
import { getFormValues } from 'redux-form'

import { PHCont } from './styled'
import { StdCard } from 'components'
import { ProcessRow } from './ProcessRow'

const PRProcessHistory = (props) => {
  const { valueForm } = props
  const comments = valueForm.comments || []

  return (
    <PHCont>
      <StdCard title='Comment' style={{ flex: 1, marginTop: '15px'}}>
        {
          comments.map((item,i)=>{
            return (<ProcessRow data={item}/>)
          })
        }
      </StdCard>
    </PHCont>
  )
}

const mapStateToProps = (state) => ({
  valueForm : getFormValues('formPO')(state)||{}
})

const mapDispatchToProps = {
}

export default connect(mapStateToProps, mapDispatchToProps)(PRProcessHistory)
